/**
 * True when getAnalyticsReport returned a usable scorecard
 * (at least one correct / incorrect / unattempted count).
 */
export const isExactSummaryAvailable = (basicAnalytics) => {
  if (!basicAnalytics || typeof basicAnalytics !== "object") return false;

  const correct = Number(basicAnalytics.total_correct);
  const incorrect = Number(basicAnalytics.total_incorrect);
  const unattempt = Number(basicAnalytics.total_un_attempt);
  const counts = [correct, incorrect, unattempt];

  if (counts.every((value) => Number.isNaN(value))) return false;

  return (
    (Number.isNaN(correct) ? 0 : correct) +
      (Number.isNaN(incorrect) ? 0 : incorrect) +
      (Number.isNaN(unattempt) ? 0 : unattempt) >
    0
  );
};

export default isExactSummaryAvailable;
